// @ts-nocheck

export const localeCodes =  [
  "hu",
  "en"
]
export const localeLoaders = {
  hu: [],
  en: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "hu",
    label: "HU",
    language: "hu"
  },
  {
    code: "en",
    label: "EN",
    language: "en"
  }
]

